import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import FontIcon from '../../../../../SPRINTA/atoms/FontIcon'
import { Text, FormGroup, Select } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'
import  GoogleMaps, { ComponentForm } from '../../../../../SPRINTA/third-party/GoogleMapsForm'

import { saveExperience, experienceTypes } from '../../_utils'

class WhereAndWhat extends Component {
    

    state = {
        types: 'loading',
        subtypes: null,
    }

    constructor(props) {
        super(props)
        this.locationInput = null

        experienceTypes()
        .then(resp => {
            this.setState({
                types: resp.experienceTypes
            }, () => {
                if(props.data.experience.experienceTypeId) 
                this.loadSubTypes(props.data.experience.experienceTypeId)
            })
        })
    }
    
    componentDidMount() {
        GoogleMaps(maps => {
            this.init(maps)
        })
    }

    init(maps) {
        let autocomplete = new maps.places.Autocomplete(this.location.refs.input, {
            types: ['(cities)']
        })

        this.location.refs.input.addEventListener('blur', event => {
            let target = event.target
            if(target.value !== '') return;

            this.props.setData({
                experience: {
                    ...this.props.data.experience,
                    cityLat: null,
                    cityLon: null,
                    country: null,
                    state: null,
                    city: null
                }
            }, () => {
                this.handleChange(this.location.refs.input)
            })
        })

        autocomplete.addListener('place_changed', function() {
            let place = autocomplete.getPlace();
            place = ComponentForm(place)
            if(!place) return

            this.location.refs.input.value = `${place.locality} - ${place.administrative_area_level_1}`

            this.props.setData({
                experience: {
                    ...this.props.data.experience,
                    cityLat: place.lat,
                    cityLon: place.lng,
                    country: place.country,
                    state: place.administrative_area_level_1,
                    city: place.locality
                }
            }, () => {
                this.handleChange(this.location.refs.input)
            })

        }.bind(this))
    }

    loadSubTypes(id) {
        let subtypes =  null
        if(id) 
        subtypes = this.state.types.find(item => parseInt(item.id, 10) === parseInt(id, 10)).subtypes

        this.setState({
            subtypes
        })
    }

    handleChange(target, index) {
        let experience = this.props.data.experience

        if(target.name === 'experienceTypeId') {
            experience.experienceSubtypeIds = ['']
            this.loadSubTypes(target.value)
        }

        let v = target.value

        if(index || index === 0) {
            v = this.props.data.experience[target.name]
            v[index] = target.value
        }
        
        experience[target.name] = v

        this.props.setData({
            experience
        }, () => {
            this.validAndSaveField(target)
        })
    }

    validAndSaveField(target) {
        const { name, value } = target

        if(this.hasFieldError[name]()) return;

        const form = {}
        if(name === 'location') {
            form['city'] = this.props.data.experience.city
            form['cityLat'] = this.props.data.experience.cityLat
            form['cityLon'] = this.props.data.experience.cityLon
            form['state'] = this.props.data.experience.state
        }

        if(name === 'experienceTypeId') {
            form['experienceTypeId'] = value
        }

        if(name === 'experienceSubtypeIds') {
            form[`experienceSubtypeIds[0]`] = value
        }

        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        location: () => {
            const { cityLon, cityLat, city, state } = this.props.data.experience
            if(!cityLon || !cityLat || !city || !state) {
                let error = "Selecione uma localização"
                this.location.setError(error)
                return {
                    element: this.location.refs.input,
                    error
                }
            }
            return false
        },
        experienceTypeId: () => {
            if(!this.props.data.experience.experienceTypeId) {
                let error = "Selecione uma opção"
                this.refs.experienceTypeId.setError(error)
                return {
                    element: this.refs.experienceTypeId.refs.select,
                    error
                }
            }
            return false
        },
        experienceSubtypeIds: () => {
            if((!this.props.data.experience.experienceSubtypeIds || !this.props.data.experience.experienceSubtypeIds[0]) && this.refs.experienceSubtypeIds) {
                let error = "Selecione uma opção"
                this.refs.experienceSubtypeIds.setError(error)
                return {
                    element: this.refs.experienceSubtypeIds.refs.select,
                    error
                }
            }
            return false
        }
    }

    inStep() {
        let data = this.props.data.experience
        return data.city || data.experienceSubtypeId || data.experienceSubtypeIds ? true  : false
    }

    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    render() {
        let data = this.props.data.experience

        return (
            <ContentInfo
                title='Onde e o que será?'
                description='Informe a cidade onde sua experiência vai ocorrer e qual a categoria de sua experiência:'
                steps={this.props.steps}
                >

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Qual a cidade da sua experiência?
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Text
                                label='Qual a cidade da sua experiência?'
                                TrailingIcon={() => <FontIcon name='search' color='#f50' />}
                                ref={ref => this.location = ref}
                                name='location'
                                defaultValue={`${data.city && data.state ? `${data.city}, ${data.state}` : ''}`}
                                />
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Qual a categoria de sua expêriencia?
                            </Display>
                        </FormGroup>
                    </Col>
                </Row>
                
                <Row>
                    <Col size='12 12 8 5'>
                        <FormGroup>
                            <Select
                                label='O que será sua experiência?'
                                name="experienceTypeId"
                                ref={"experienceTypeId"}
                                value={this.props.data.experience.experienceTypeId}
                                onChange={e => this.handleChange(e.target)}
                                >
                                <option value=''>Selecione</option>
                                {this.state.types !== 'loading' && (
                                    this.state.types.map(type => (
                                        <option value={type.id} key={type.id}>{type.nameBr}</option>
                                    ))
                                )}
                            </Select>
                        </FormGroup>
                    </Col>
                </Row>
                {this.props.data.experience.experienceTypeId ? (
                    <Row>
                        <Col size='12 12 8 5'>
                            <FormGroup>
                                <Select
                                    label='Qual o tipo de atividade esportiva?'
                                    name={`experienceSubtypeIds`}
                                    ref='experienceSubtypeIds'
                                    value={this.props.data.experience.experienceSubtypeIds && this.props.data.experience.experienceSubtypeIds[0] ? this.props.data.experience.experienceSubtypeIds[0].experienceSubtypeId : ''}
                                    onChange={e => this.handleChange(e.target, 0)}>
                                    <option value=''>Selecione</option>
                                    {this.state.subtypes && (
                                        this.state.subtypes.map(type => (
                                            <option value={type.id} key={type.id}>{type.nameBr}</option>
                                        ))
                                    )}
                                </Select>
                            </FormGroup>
                        </Col>
                    </Row>
                ) : null}
                
                
            </ContentInfo>
        )
    }

}

export default WhereAndWhat


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/WhereAndWhat/index.js